import React, { Component } from 'react';
import './styles.css';

class BodyLeft extends Component {
	render() {
		return (
			<div className="sales-test-layout-body-left">{this.props.children}</div>
		);
	}
}
export default BodyLeft;
